export default function (_ref) {
  var store = _ref.store,
      error = _ref.error,
      redirect = _ref.redirect,
      res = _ref.res;

  if (!store.state.authUser) {
    error({
      message: 'Permission deniede',
      statcusCode: 401
    });
  }
  if (!store.state.authUser) {
    if (store.state.authUser === null) {
      return redirect('/account/customer');
    }
    if (store.state.authUser.roleID == null) {
      return redirect('/account/customer');
    }
    if (store.state.authUser.roleID.toLowerCase() === 'admin') {
      return redirect('/account/musubi');
    }
    if (store.state.authUser.roleID.toLowerCase() === 'customer') {
      return redirect('/account/customer');
    }
    if (store.state.authUser.roleID.toLowerCase() === 'partner') {
      return redirect('/account/partner');
    }
    // window.location.href = ''
  }
}


//////////////////
// WEBPACK FOOTER
// ./middleware/auth.js
// module id = ./middleware/auth.js
// module chunks = 82